export default __webpack_public_path__ + "static/media/0463.c01f4824.jpg";